export const environment = {
    production: false,
    urlBack: 'https://dev.api.atalaya.ai/api/v1/',
    urlFront: 'https://dev.app.atalaya.ai/login',
    client_id: 'tqIXWTdGtGSpSFMPXsuT3lRSXJO05TpexRjf51YR',
    client_secret:
        'ktSB9HCvSvqQkhUNv71GUf0vLZQsB33AF1CG4ksRGtA52hgZH0Cu4QoC6qPiOeZ3iGIc9O5QcyfDaEkCkRJJaBCRyfaq3nM4lYJeFAHzHY4L89zcC1RGPcdf7pr9CjJz',
};
